// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ympy","disabled":"styles_disabled__1d0RQ"};